import trFlag from "../../assets/flags/TR.png";
import enFlag from "../../assets/flags/EN.png";

export const languageLists = [
    {text: 'TR', value: 'tr', imgSource: trFlag},
    {text: 'EN', value: 'en', imgSource: enFlag},
]
